import type { ReactElement } from 'react';

/**
 * 사람에게는 보이지 않는 미끼 칸 — 공개 폼(교육 문의·설문)이 함께 쓴다.
 *
 * 봇은 폼을 눈으로 보지 않고 입력마다 값을 채우므로 여기까지 채운다 — 서버는 그 요청을
 * 조용히 버린다. 사람이 실수로 채우는 일이 없도록 세 겹으로 가린다:
 * 화면 밖으로 밀어내고(`absolute` + 음수 좌표), 탭 순서에서 빼고(`tabIndex={-1}`),
 * 화면낭독기에도 감춘다(`aria-hidden`). 자동완성도 끈다 — 브라우저가 대신 채우면
 * 진짜 접수가 버려진다.
 *
 * `display:none` 을 쓰지 않는 이유: 요즘 봇은 그 속성을 보고 덫을 알아본다.
 *
 * 이름은 `homepage` 로 고정이다 — 서버 스키마가 그 이름으로 받는다.
 */
export function Honeypot({ id }: { id: string }): ReactElement {
  return (
    <div aria-hidden="true" className="absolute left-[-9999px] h-0 w-0 overflow-hidden">
      <label htmlFor={id}>홈페이지 주소</label>
      <input id={id} name="homepage" type="text" tabIndex={-1} autoComplete="off" />
    </div>
  );
}
